// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sinistea: PokeData = {
  "id": 854,
  "name": "sinistea",
  "height": 1,
  "weight": 2,
  "base_experience": 62,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "mega-drain",
    "withdraw",
    "protect",
    "giga-drain",
    "sweet-scent",
    "shadow-ball",
    "memento",
    "astonish",
    "aromatherapy",
    "sucker-punch",
    "nasty-plot",
    "shell-smash",
    "aromatic-mist"
  ],
  "moves": [
    "protect",
    "shadow-ball",
    "aromatherapy",
    "poltergeist",
    "shadow-dagger",
    "curse",
    "spectral-snatch",
    "shadow-sneak",
    "lick",
    "soul-sacrifice",
    "night-shade",
    "shadow-claws",
    "spectral-chain"
  ],
  "evolution_chain": {
    "id": 449,
    "item": null,
    "species": [
      {
        "name": "sinistea",
        "order": 854,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "polteageist",
        "order": 855,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 854,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "cracked-pot"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 44.75,
    "speed": 50,
    "ability_power": 74
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
